import { render } from "./PembayaranOpsiMakanModal_c.vue?vue&type=template&id=0e418a3b&scoped=true"
import script from "./PembayaranOpsiMakanModal_c.vue?vue&type=script&lang=js"
export * from "./PembayaranOpsiMakanModal_c.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0e418a3b"

export default script